/**
 * Resolve a featured image URL from an Algolia hit.
 * Prefers indexed strl-medium / strl-small sizes; falls back to legacy flat `.url`.
 *
 * @param {object} hit Algolia hit.
 * @return {string}
 */
export function strl_hit_featured_image(hit) {
	if (!hit) {
		return '';
	}

	if (hit.featured_image) {
		return String(hit.featured_image);
	}

	const acfImage = hit['settings-group_post-featured-image'];
	if (!acfImage || typeof acfImage !== 'object') {
		return '';
	}

	const preferredSizes = ['strl-medium', 'strl-small'];
	for (let i = 0; i < preferredSizes.length; i++) {
		const size = preferredSizes[i];
		if (acfImage[size] && acfImage[size].url) {
			return String(acfImage[size].url);
		}
	}

	if (acfImage.url) {
		return String(acfImage.url);
	}

	return '';
}
